import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      static i2g(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.p2f_1 = level;
        $this.q2f_1 = marker;
        $this.r2f_1 = loggerName;
        $this.s2f_1 = message;
        $this.t2f_1 = cause;
        $this.u2f_1 = payload;
        $this.v2f_1 = timestamp;
        return $this;
      }
      static j2g(level, marker, loggerName, eventBuilder) {
        return this.i2g(level, marker, loggerName, eventBuilder.a2g_1, eventBuilder.b2g_1, eventBuilder.c2g_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.p2f_1.toString() + ', marker=' + toString(this.q2f_1) + ', loggerName=' + this.r2f_1 + ', message=' + this.s2f_1 + ', cause=' + toString(this.t2f_1) + ', payload=' + toString(this.u2f_1) + ', timestamp=' + this.v2f_1.toString() + ')';
      }
      hashCode() {
        var result = this.p2f_1.hashCode();
        result = imul(result, 31) + (this.q2f_1 == null ? 0 : hashCode(this.q2f_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.r2f_1) | 0;
        result = imul(result, 31) + (this.s2f_1 == null ? 0 : getStringHashCode(this.s2f_1)) | 0;
        result = imul(result, 31) + (this.t2f_1 == null ? 0 : hashCode(this.t2f_1)) | 0;
        result = imul(result, 31) + (this.u2f_1 == null ? 0 : hashCode(this.u2f_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.v2f_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.p2f_1.equals(tmp0_other_with_cast.p2f_1))
          return false;
        if (!equals(this.q2f_1, tmp0_other_with_cast.q2f_1))
          return false;
        if (!(this.r2f_1 === tmp0_other_with_cast.r2f_1))
          return false;
        if (!(this.s2f_1 == tmp0_other_with_cast.s2f_1))
          return false;
        if (!equals(this.t2f_1, tmp0_other_with_cast.t2f_1))
          return false;
        if (!equals(this.u2f_1, tmp0_other_with_cast.u2f_1))
          return false;
        if (!(this.v2f_1 === tmp0_other_with_cast.v2f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
